import script from "./CrewDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./CrewDashboard.vue?vue&type=script&setup=true&lang=js"

import "./CrewDashboard.vue?vue&type=style&index=0&id=76b4cae7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76b4cae7"]])

export default __exports__